module.exports = __webpack_public_path__ + "img/xp-tb-customer-grosvenor.b440519.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/gamification/xp-tb-customer-grosvenor.png
// module id = lFpH
// module chunks = 39 44